<div fxLayout="row wrap" fxLayout.lt-sm="column" fxLayoutAlign="start center" fxLayoutAlign.lt-sm="start" fxLayoutGap="10px">
  @if (items?.()?.length) {
    @for (item of items?.(); track $index) {
      <mat-checkbox
        data-cy="iot-platform-ui-checkbox-input"
        class="iot-platform-ui-checkbox-input iot-platform-ui-checkbox-input--{{ selectByFn(item) }}"
        style="line-height: 35px; padding-left: 4px"
        [fxFlex]="fxFlexOption?.() ? '0 1 calc(' + $safeNavigationMigration(fxFlexOption?.()) + ' - 10px)' : 'auto'"
        [fxFlex.lt-sm]="'100%'"
        [value]="selectByFn(item)"
        [checked]="isChecked(item)"
        (change)="onSelectionChange($event, true)"
        [disabled]="isOptionDisabled ? isOptionDisabled(item) : $safeNavigationMigration(disabled?.())"
        [ngClass]="{ 'capitalize-first-letter': $safeNavigationMigration(capitalized?.()) }"
      >
        <div class="flex items-center justify-center">
          @if (item?.icon) {
            <mat-icon [class]="item?.iconCssClassName">{{ item?.icon }}</mat-icon>
          }
          <span [class]="item?.cssClassName">{{ displayByFn(item) | translate }}</span>
        </div>
      </mat-checkbox>
    }
  }
</div>
